import {
  createPaginatedSupabaseQuery,
  createSearchSupabaseQuery,
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnGetApiFunction,
  spawnListInApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
  type SearchOptionFilters,
} from "@/utils/api";

import type { QueryPaginationFilters } from "@/utils/pagination";

const table = "part_categories";
const query = `*, part_models(name)`;
export const apiConfigPartCategories: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name"],
  sortables: ["name", "created_at", "updated_at"],
};

export const getPartCategory = spawnGetApiFunction({ table, query });
export const getPartCategoriesByIds = spawnListInApiFunction({ table, query });
export const createPartCategory = spawnCreateApiFunction({ table, query });
export const updatePartCategory = spawnUpdateApiFunction({ table, query });
export const deletePartCategory = spawnDeleteApiFunction({ table });

export async function getPaginatedPartCategories({
  dataTableOptions,
  customFilters,
  customOrFilters,
}: QueryPaginationFilters) {
  const { data, count, error } = await createPaginatedSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartCategories.searchables,
      sortables: apiConfigPartCategories.sortables,
    },
    dataTableOptions,
    customFilters,
    customOrFilters,
  });

  if (error) throw error;
  return { data, count };
}

export async function getPartCategoriesBySearch({
  searchOptions,
  customFilters,
  customOrFilters,
  limit,
}: SearchOptionFilters) {
  const { data, count, error } = await createSearchSupabaseQuery({
    baseOptions: {
      table,
      query,
      searchables: apiConfigPartCategories.searchables,
      sortables: apiConfigPartCategories.sortables,
    },
    searchOptions,
    customFilters,
    customOrFilters,
    limit,
  });

  if (error) throw error;
  return { data, count };
}
